export enum InventoryLocationTypeEnum {
    Primary,
    DamagedExpired,
    Custom,
    Compounds
}